'use client';

import { cn } from '@fshr/shared-react';
import BevSafeText from '../bev-safe-text';
import Button from '../button';
import { UserPanelTabId } from '@fshr/shared/types';

type TabsProps = {
	tabs: {
		id: UserPanelTabId;
		label?: string;
		getIcon?: () => React.JSX.Element;
		getLabel?: () => React.JSX.Element;
	}[];
	selectedTab: UserPanelTabId;
	onTabSelected: (tabId: UserPanelTabId) => void;
};
export const Tabs = ({ tabs, selectedTab, onTabSelected }: TabsProps) => {
	return (
		<div className="w-full flex flex-row border-border-subtle h-[40px] md:h-[50px]" role="tablist">
			{tabs.map(tab => {
				return (
					<Button
						key={tab.id}
						role="tab"
						aria-label={tab.label}
						aria-selected={selectedTab === tab.id ? 'true' : undefined}
						aria-controls={`${tab.id}section`}
						id={`${tab.id}-tab`}
						tabIndex={0}
						intent="unstyled"
						className={cn(
							'w-1/3 pt-100 pb-100 md:pt-150 md:pb-150 padding-inline-l cursor-pointer flex flex-row justify-center items-center spacing-inline-s',
							{
								'border-b border-b-border-strong border-b-3 pb-[7px] md:pb-[12px]':
									selectedTab === tab.id,
								'text-subtitle2': !!tab.label,
							}
						)}
						onClick={() => onTabSelected(tab.id)}
					>
						{tab.label && (
							<div className="flex flex-row items-center gap-[10px]">
								{tab.getIcon && <div>{tab.getIcon()}</div>}
								<p className="text-text-heading whitespace-nowrap text-center text-subtitle2 text-[14px]">
									<BevSafeText>{tab.label}</BevSafeText>
								</p>
							</div>
						)}
						{tab.getLabel?.()}
					</Button>
				);
			})}
		</div>
	);
};
